/* eslint-disable */
export default {
  logging: 'Registrando...',
  logCall: 'Registrar chamada',
  editLog: 'Editar log',
  select: 'Selecionar registro',
  OnHold: 'Em espera',
  Ringing: 'Chamando',
  CallConnected: 'Chamada conectada',
  unknownUser: 'Usuário desconhecido',
  unknownNumber: 'Anônimo',
  unavailable: 'Indisponível',
  viewDetails: 'Exibir detalhes',
  conferenceCall: 'Chamada em conferência',
  callerId: 'ID da chamada',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"callerId"@#@ @source: @#@"Caller ID"@#@
